var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "xui-carousel",
    {
      attrs: {
        arrow: "always",
        height: _vm.bannerHeight + "px",
        interval: 10000
      }
    },
    _vm._l(_vm.banner, function(it, index) {
      return _c(
        "xui-carousel-item",
        { key: it.title },
        [
          _c(
            "xui-row",
            [
              _c("xui-col", { staticClass: "img-wrap", attrs: { span: 24 } }, [
                _c("a", { attrs: { href: it.url } }, [
                  _c("img", {
                    ref: "bannerHeight",
                    refInFor: true,
                    staticClass: "img-detail",
                    attrs: { src: it.logoUrl, alt: it.title },
                    on: { load: _vm.imgLoad }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "carousel-item-info" },
                  [
                    index === 0
                      ? _c(
                          "router-link",
                          {
                            staticClass: "carousel__link",
                            attrs: { to: "report" }
                          },
                          [_c("span", [_vm._v(" 提交漏洞")])]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ec09f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ec09f5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Banner.vue
// module id = null
// module chunks = 